import { User, Avatar } from "@/types";

export function getUserAvatar(user: User): Avatar | undefined {
  return user.profile?.avatar || user?.avatar;
}

export function getUserAvatarUrl(user: User): string {
  return getUserAvatar(user)?.url ?? "";
}
